import packageManifest from "../package.json" with { type: "json" };

export const packageVersion: string = packageManifest.version;
